<!-- 卡详情 web/card-detail?cardId=165 -->

<template>
  <div class="page">
    <div class="card-info">
      <div class="card">
        <van-cell style="text-align: left">
          <template #title>
            <b style="font-size: 16px">{{ cardInfo.cardId ? cardInfo.cardId.toString().padStart(10, "0") : "" }}</b>
          </template>
          <template>
            余额:
            <b>{{ cardInfo.type === 2 ? cardInfo.quantity : cardInfo.quantity / 100 }}</b>
            <img v-if="cardInfo.type === 1"
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
              width="16" />
            <span v-else>次</span>
          </template>
        </van-cell>

        <div ref="qrCodeUrl" class="qrcode"></div>

        <div style="text-align: left">
          <van-cell title="使用说明">
            <template #label>
              <ul v-if="cardInfo.offlineFlag === true" style="list-style: none">
                <li>本卡支持线上兑换；本卡支持线下门店展示核销；</li>
              </ul>
              <ul v-else style="list-style: none">
                <li>本卡仅支持线上兑换， 禁止线下刷卡使用；</li>
              </ul>
            </template>
          </van-cell>

          <van-cell v-if="cardInfo.multipleZone !== true" title="使用范围" class="budo-35">
            <template #label>
              <span v-for="cate of allowCate" :key="cate.id" style="margin-right: 4px">{{ cate.name }}</span>
            </template>
          </van-cell>

          <van-cell title="使用区域" v-if="cardInfo.regionList && cardInfo.regionList.length > 0">
            <template #label>
              <span v-for="region of cardInfo.cityCode" :key="region" style="margin-right: 4px">
                {{ region | cityCodeToName }}
              </span>
            </template>
          </van-cell>

          <div v-for="region of cardInfo.regionList" :key="region.zoneId"
            style="background-color: #e5e5e5; padding: 8px 0">
            <van-cell :title="'卡券分区' + region.zoneId">
              <template #label>
                <van-cell title="使用范围" class="budo-53">
                  <template #label>
                    <span v-for="regionCate of region.allowCateList" :key="regionCate.cateId"
                      style="margin-right: 4px">{{ regionCate.name }}</span>
                  </template>
                </van-cell>
                <van-cell title="余额">
                  <template #label>
                    <b>{{ cardInfo.type === 2 ? region.quantity : region.quantity / 100 }}</b>
                    <img v-if="cardInfo.type === 1"
                      src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                      width="16" />
                    <span v-else>次</span>
                  </template>
                </van-cell>
              </template>
            </van-cell>
          </div>

          <van-cell title="消费明细">
            <template #label>
              <van-cell-group>
                <van-cell v-for="log in cardLogs" :key="log.cardLogId" :title="log.createTime">
                  <span v-if="log.quantity > 0">+</span>
                  {{ log.cardUseType === 2 ? log.quantity : (log.quantity / 100).toFixed(2) }}
                  <img v-if="log.cardUseType === 1"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                    width="16" />
                  <span v-else>次</span>
                </van-cell>
              </van-cell-group>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardDetail, getCardLog } from "@/api/user";
import TopicListIndex from "@/components/common/topic-list-index";
import cityData from "../../api/pca-code.json";
import { GOODS_CATE_INFO } from "@/api/constant";
import QRCode from "qrcodejs2";

export default {
  name: "card-detail",

  components: { TopicListIndex },

  data() {
    return {
      cardInfo: {},
      activeNames: ["1"],
      allowCate: [],
      cardLogs: [],
    };
  },

  created() {
    const cardId = this.$route.query.cardId;

    getCardDetail(cardId).then((res) => {
      this.cardInfo = res.data;

      // 新的分类 配了哪些有哪些
      for (let idx in this.cardInfo.banCateList) {
        let each = this.cardInfo.banCateList[idx];
        if (each.cateId > 999) {
          this.allowCate.push(each);
        }
      }

      // 老的分类 没配哪些有哪些
      for (let key in GOODS_CATE_INFO) {
        // 如果未排除的话 就把老板块加上
        const cate = GOODS_CATE_INFO[key];

        if (
          this.cardInfo.banCateIds.indexOf(cate.id) < 0 &&
          cate.id !== GOODS_CATE_INFO.festival.id
        ) {
          if (cate.id < 999) {
            this.allowCate.push(cate);
          }
        }
      }

      if (res.data.qr) {
        new QRCode(this.$refs.qrCodeUrl, {
          text: res.data.qr, // 需要转换为二维码的内容
          width: 236,
          height: 236,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    });

    getCardLog(cardId).then((res) => {
      this.cardLogs = res.data;
    });
  },

  filters: {
    cityCodeToName(code) {
      for (const nameKey in cityData) {
        const city = cityData[nameKey];
        if (city.code === code) {
          return city.name;
        }

        if (city.children) {
          const node = city.children.find((c) => c.code === code);
          if (node) {
            return node.name;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: #e5e5e5;
  padding: 8px;
  width: 95vw;

  .card-info {
    margin-bottom: 50px;
    border-radius: 5px;
  }

  .card {
    background-color: #fff;
    border-radius: 5px;
    text-align: center;
    margin-top: 8px;
  }
}

.qrcode {
  display: inline-block;

  img {
    width: 256px;
    height: 256px;
    background-color: #333; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
    box-sizing: border-box;
  }
}
</style>
